import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const SESSION_ANALYSIS_PATH = '/Laptura/session-analysis';
export const SESSION_ANALYSIS_TABS = ['overview', 'telemetry', 'compare', 'notes'];

export function sessionAnalysisTab(params) {
  const tab = params.get('tab');
  return SESSION_ANALYSIS_TABS.includes(tab) ? tab : 'overview';
}

export function LegacyCompareRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('tab', 'compare');
  return <Navigate replace to={{ pathname: SESSION_ANALYSIS_PATH, search: `?${params}`, hash: location.hash }} />;
}
